import "./styles.scss";
import { ReactElement, useEffect, useRef } from "react";

interface ITocDrawer {
  onClose: () => void;
  children: string;
  renderedId: string;
}

export const TocDrawer = ({ onClose, children, renderedId }: ITocDrawer): ReactElement => {
  const tocContainer = useRef(null);

  useEffect(() => {
    document.querySelector(".toc li.active")?.classList.remove("active");
    const activeItem = document.getElementById(renderedId);

    if (activeItem) {
      activeItem.classList.add("active");

      if (tocContainer.current) {
        const activeItemPosition = activeItem.getBoundingClientRect();
        const containerPosition = (tocContainer.current as HTMLElement).getBoundingClientRect();

        if (activeItemPosition.top < containerPosition.top) {
          activeItem.scrollIntoView({ block: "start" });
        }

        if (activeItemPosition.bottom > containerPosition.bottom) {
          activeItem.scrollIntoView({ block: "end" });
        }
      }
    }
  }, [renderedId]);

  return (
    <nav className="drawer toc-drawer">
      <div className="header">
        <h3 className="title">Table of contents</h3>
        <button className="close-button" aria-label="Close button" onClick={onClose}>
          <div className="close-icon" />
        </button>
      </div>
      {/* <div className="tabs">
        <button className="tab-item">Content</button>
        <button className="tab-item">Bookmarks</button>
        <button className="tab-item">Recent</button>
      </div> */}
      <div ref={tocContainer} className="toc" dangerouslySetInnerHTML={{ __html: children }}></div>
    </nav>
  );
};
